/** Normalize stored image URLs for use in `<img src>`. */
export function normalizeImageSrc(raw: string | null | undefined): string | null {
  if (raw == null || typeof raw !== 'string') return null;
  const t = raw.trim();
  if (!t) return null;
  if (t.startsWith('//')) return `https:${t}`;
  if (t.startsWith('/') && !t.startsWith('//')) return t;
  if (/^https?:\/\//i.test(t)) return t;
  if (t.startsWith('data:image/')) return t;
  if (/^[a-z0-9.-]+\.[a-z]{2,}\//i.test(t)) return `https://${t}`;
  return null;
}

export function isUsableImageSrc(url: string | null | undefined): url is string {
  return normalizeImageSrc(url) !== null;
}
